//  Carica "vecchi" CSS di personalizzazione di frontend (bt-3.2, default, blue|gark|grey|green)
import React, {  Component} from "react";
import {  PropTypes} from 'prop-types';



class LegacyTheme extends Component {
  constructor(props) {
    super();
    //
    this.elementsToRemove = ['#titles-font', '#paragraphs-font', '[href*="/frontend/static/frontend"]'];
  }

  componentDidMount() {
    this.elementsToRemove.forEach((o) => {
      this.removeElement(o);
    });
    //

    const subpath = this.props.mode == 'subscription' ? 'new/' : '';

    //  BT
    const btLink = document.createElement("link");
    btLink.rel = "stylesheet";
    btLink.href = '/css/bt-3.2.css';
    btLink.id = 'legacy-bt-style';
    document.head.appendChild(btLink);
    //
    //  default
    const defaultLink = document.createElement("link");
    defaultLink.rel = "stylesheet";
    defaultLink.href = `/frontend/css/formBuilder/${subpath}Default.css`;
    defaultLink.id = 'legacy-frontend-style';
    document.head.appendChild(defaultLink);
    //
    //  theme
    if (this.props.style !== 'Default') {
      const themeLink = document.createElement("link");
      const style = this.props.style.charAt(0).toUpperCase() + this.props.style.substring(1);
      themeLink.rel = "stylesheet";
      themeLink.href = `/frontend/css/formBuilder/${subpath}${style}.css`;
      themeLink.id = 'legacy-custom-style';
      document.head.appendChild(themeLink);
    }

  }

  removeElement(selector) {
    const el = document.querySelector(selector);
    if (el) {
      el.parentNode.removeChild(el);
    }
  }

  render() {
    return null;
  }

}


LegacyTheme.propTypes = {
  style: PropTypes.oneOf(['default', 'blue', 'dark', 'gray', 'green']),
  mode: PropTypes.oneOf(['subscription', 'autoprofile']),
};

export default LegacyTheme;